<div [showHideAnimation]="panel">
  @if (title) {
    <p>{{ title }}</p>
  }
  <div>
    <gstar-template-factory />
  </div>
</div>
